// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import { Container } from "./styles";

// Components
import { WebpChartItem } from "./WebpChartItem";
import { WebpChartLegendItem } from "./WebpChartLegendItem";

// Types
type WebpChartProps = {
    chartConfig?: any;
    className: string;
};

export const WebpChart: FunctionComponent<WebpChartProps> = ({ chartConfig, children }) => {
    const { datasets, labels } = chartConfig.data.data;
    const datas = datasets[0].data as number[];
    const colors = datasets[0].backgroundColor as string[];

    const legs = datas.map((value, index) => ({
        label: labels[index],
        value: value,
        color: colors[index]
    }));

    return (
        <Container>
            <div className="wrapper-webp-chart-item">
                <WebpChartItem {...chartConfig} />
            </div>

            <div className="chart-info">
                <div className="wrapper-content">{children}</div>

                <div className="wrapper-legends">
                    {legs.map((leg) => (
                        <WebpChartLegendItem key={leg.value} color={leg.color} value={leg.value} label={leg.label}></WebpChartLegendItem>
                    ))}
                </div>
            </div>
        </Container>
    );
};
